/**
 * @breathly/web — Supabase client.
 *
 * Per SUPABASE.md and SECURITY.md: the anon key is safe for client-side use
 * (RLS enforces row-level permissions). The service role key is NEVER exposed
 * to the browser.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

let _client: SupabaseClient | null = null;

export function getSupabaseConfigError(): string | null {
  if (!supabaseUrl || !supabaseAnonKey) {
    return 'Supabase credentials are not configured for this build.';
  }
  return null;
}

export function getSupabase(): SupabaseClient {
  if (!_client) {
    const configError = getSupabaseConfigError();
    if (configError) throw new Error(configError);
    _client = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    });
  }
  return _client;
}
